import { useState } from 'react'
import { INTEGRATION_QUERIES } from 'routes/constants'
import { ScenariosCard } from 'routes/components/Features/ScenarioCard'
import { getIntegrationUrl } from 'routes/Integrations/helpers'
import { ScenarioTemplateCompact } from 'routes/Scenarios/helpers/types'
import { Button } from 'ui-kit/actions/button'
import clsx from 'clsx'
import common from 'routes/Integrations/Integration/Integration.module.scss'
import classes from './Scenarios.module.scss'

const INITIAL_SCENARIOS_COUNT = 10

export function IntegrationScenarios({
  scenarios,
  integrationLink,
}: {
  scenarios: ScenarioTemplateCompact[]
  integrationLink: string
}) {
  const [loadMore, setLoadMore] = useState(false)

  const toggleLoadMoreBtn = () => {
    if (loadMore) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
    setLoadMore(!loadMore)
  }

  const isMoreScenariosAvailable = scenarios.length > INITIAL_SCENARIOS_COUNT

  const numberOfAdditionalScenarios = scenarios.length - INITIAL_SCENARIOS_COUNT

  const visibleScenarios = loadMore
    ? scenarios
    : scenarios.slice(0, INITIAL_SCENARIOS_COUNT)

  return (
    <>
      <ul className={clsx(common.integrationList, classes.list)}>
        {visibleScenarios.map((scenario) => (
          <IntegrationScenariosCard
            key={scenario.key}
            scenario={scenario}
            integrationKey={integrationLink}
          />
        ))}
      </ul>

      {isMoreScenariosAvailable && (
        <Button
          category='secondary'
          onClick={toggleLoadMoreBtn}
          className={classes.button}
        >
          {loadMore
            ? 'Hide additional scenarios'
            : `Show ${numberOfAdditionalScenarios} additional scenarios`}
        </Button>
      )}
    </>
  )
}

const IntegrationScenariosCard = ({
  scenario,
  integrationKey,
}: {
  scenario: ScenarioTemplateCompact
  integrationKey: string
}) => {
  const scenarioPageLink = getIntegrationUrl(
    integrationKey,
    INTEGRATION_QUERIES.SCENARIOS,
    scenario.key,
  )

  return (
    <li className={classes.item}>
      <ScenariosCard
        scenario={scenario}
        href={scenarioPageLink}
        className={classes.card}
      />
    </li>
  )
}
